import React, { Fragment } from 'react';
import './tooltip-component.scss';

const tooltip = ({ message, children }) => {
  return (
    <Fragment>
      <div className="tooltip_box">
        {children}
        {message && <div className="tooltip">{message}</div>}
      </div>
    </Fragment>
  );
};

export default tooltip;
